import { NotificationTemplate } from "@/modules/Notification/models/NotificationTemplate";
import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { UpdateNotificationTemplate } from "../models/update-template.model";
import { NotificationTemplateFilterResponse } from "../models/notification-template-filter-response.model";
import { NotificationTemplateFilter } from "../models/notification-template-filter.model";
import { ParameterConfig } from "../models/parameter-config.model";

export class NotificationTemplateServices {
  private baseUrl: string;
  private formsBaseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_NOTIFICATIONS_API}/notification-templates`;
    this.formsBaseUrl = `${process.env.VUE_APP_FORMS_API}/lists`;
  }

  async syncTemplates(): Promise<Response<Array<NotificationTemplate> | void>> {
    const serviceUrl = `${this.baseUrl}/sync`;
    const response = await axios.post(serviceUrl);
    return response.data;
  }

  async filterTemplates(
    filters?: NotificationTemplateFilter
  ): Promise<Response<NotificationTemplateFilterResponse | void>> {
    const serviceUrl = `${this.baseUrl}/filter`;
    const response = await axios.get(serviceUrl, {
      params: filters
    });
    return response.data;
  }

  async getTemplateById(
    id: string
  ): Promise<Response<NotificationTemplate | void>> {
    const serviceUrl = `${this.baseUrl}/details/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async updateTemplate(
    template: UpdateNotificationTemplate,
    id: string
  ): Promise<Response<void>> {
    const servicesUrl = `${this.baseUrl}/${id}`;
    const response = await axios.put(servicesUrl, template);
    return response.data;
  }

  async updateList(id: string, items: Array<string>): Promise<Response<void>> {
    const serviceUrl = `${this.formsBaseUrl}/items/${id}`;
    const response = await axios.put(serviceUrl, {
      items
    });
    return response.data;
  }

  async updateStateNotificationTemplateById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async getParametersConfig(): Promise<Response<ParameterConfig[] | void>> {
    const serviceUrl = `${this.baseUrl}/parameters-notifications`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }
}
